import { useState, useEffect, useCallback, useRef } from 'react';

const slides = [
  {
    src: 'https://public.readdy.ai/ai/img_res/edited_6d418193b1e5269c0cc418275f1315b6_1ea6e443.jpg',
    alt: 'Vista aérea Multifierros Spa - Galpón industrial y camión aljibe',
  },
  {
    src: 'https://public.readdy.ai/ai/img_res/edited_f7e3dfd75fdc4fe08ba8b41358d5d5a7_cc892553.jpg',
    alt: 'Instalaciones Multifierros Spa - Vista aérea del patio industrial',
  },
  {
    src: 'https://public.readdy.ai/ai/img_res/edited_6d8dcf8b784e16689f6fada00a4da455_2cbe516f.jpg',
    alt: 'Exterior Multifierros Spa - Galpón y patio',
  },
  {
    src: 'https://public.readdy.ai/ai/img_res/edited_644ad316f697709a0addfc920d6a3dc1_fce452ca.jpg',
    alt: 'Interior Multifierros Spa - Taller de fabricación',
  },
];

const SWIPE_THRESHOLD = 50;

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const sectionRef = useRef<HTMLElement>(null);
  const startX = useRef(0);
  const isDown = useRef(false);

  const goTo = useCallback((index: number) => {
    setCurrent((index + slides.length) % slides.length);
  }, []);

  const nextSlide = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const onDown = (e: PointerEvent) => {
      isDown.current = true;
      startX.current = e.clientX;
    };
    const onMove = (e: PointerEvent) => {
      if (isDown.current) {
        e.preventDefault();
      }
    };
    const onUp = (e: PointerEvent) => {
      if (!isDown.current) return;
      const diff = startX.current - e.clientX;
      isDown.current = false;
      if (Math.abs(diff) > SWIPE_THRESHOLD) {
        if (diff > 0) {
          setCurrent((prev) => (prev + 1) % slides.length);
        } else {
          setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
        }
      }
    };

    el.addEventListener('pointerdown', onDown);
    el.addEventListener('pointermove', onMove, { passive: false });
    el.addEventListener('pointerup', onUp);
    el.addEventListener('pointerleave', onUp);
    el.addEventListener('pointercancel', onUp);

    return () => {
      el.removeEventListener('pointerdown', onDown);
      el.removeEventListener('pointermove', onMove);
      el.removeEventListener('pointerup', onUp);
      el.removeEventListener('pointerleave', onUp);
      el.removeEventListener('pointercancel', onUp);
    };
  }, []);

  return (
    <section id="inicio" ref={sectionRef} className="relative w-full h-[55vh] md:h-[68vh] lg:h-[75vh] overflow-hidden select-none touch-none cursor-grab active:cursor-grabbing">
      {/* Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.src}
            alt={slide.alt}
            className="w-full h-full object-cover object-center pointer-events-none"
            draggable={false}
          />
        </div>
      ))}

      {/* Overlay sutil para integrar el logo */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/10 to-transparent pointer-events-none" />

      {/* Indicadores de slide */}
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-10 flex gap-2.5">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
              index === current
                ? 'w-8 bg-white'
                : 'w-1.5 bg-white/50 hover:bg-white/80'
            }`}
            aria-label={`Ir a slide ${index + 1}`}
          />
        ))}
      </div>

      {/* Flechas navegación */}
      <button
        onClick={() => setCurrent((prev) => (prev - 1 + slides.length) % slides.length)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-10 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/40 transition-all cursor-pointer"
        aria-label="Anterior"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl" />
      </button>
      <button
        onClick={() => setCurrent((prev) => (prev + 1) % slides.length)}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-10 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/40 transition-all cursor-pointer"
        aria-label="Siguiente"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl" />
      </button>
    </section>
  );
}